import { CustomerDto } from '@groundfloor-platform/mgmt-service-g-sdk';
import { Typography } from '@mui/material';
import { useMobilePhoneFormatter } from '../../../../../../../ui/formatters/mobile-phone.formatter';
import { useSearchResultCustomerStyles } from './search-result-customer.styles';

export function SearchResultCustomer({ customer, projectID }: { customer: CustomerDto; projectID: string }) {
  const { firstName, preferredName, lastName, email, mobile } = customer;

  const mobilePhoneFormatter = useMobilePhoneFormatter(projectID);
  const classes = useSearchResultCustomerStyles();

  return (
    <>
      <Typography className={classes.name}>{`${firstName ? firstName + ' ' : ''}${
        preferredName ? `(${preferredName}) ` : ''
      }${lastName || ''}`}</Typography>
      <Typography className={classes.details}>{`${mobile ? mobilePhoneFormatter(mobile) : ''}${
        email && mobile ? ' | ' : ''
      }${email ? email : ''}`}</Typography>
    </>
  );
}
